import { AxiosInstance, AxiosResponse } from 'axios';
import config from '../../config';
import { ICompany, IPageableResponse } from '@recone/models';

const GET_COMPANIES_PATH = 'company/list';
const GET_COMPANY_PATH = 'company/';

export const getCompanies = (
  axiosInstance: AxiosInstance,
  page = 0,
  limit = config.service.QUERY_DEFAULT_LIMIT,
  search: string
): Promise<AxiosResponse<IPageableResponse<ICompany>>> => {
  const searchParam = search ? `&search=${encodeURIComponent(search)}` : '';
  const url = `${config.service.BASE_URL}/${GET_COMPANIES_PATH}?page=${page}&limit=${limit}${searchParam}`;
  return axiosInstance.get(url);
};

export const getCompany = (axiosInstance: AxiosInstance, companyId: string): Promise<AxiosResponse<ICompany>> =>
  axiosInstance.get(`${config.service.BASE_URL}/${GET_COMPANY_PATH}${companyId}`);
